import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import API from "../Service/Baseservice";
import "../Admin/Admin.css";
import { Eye, EyeOff } from "lucide-react";

const AdminView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const adminData = location.state?.adminData || {};
    const [admin, setAdmin] = useState(adminData || {});
    const [previewImage, setPreviewImage] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (!adminData?.admin_id) {
            API.get(`admin/${id}`)
                .then((res) => {
                    const data = res.data;
                    setAdmin(data);
                    const img = data.admin_image?.startsWith("http")
                        ? data.admin_image
                        : `http://dev-service.asraimmigration.ca/backend_service/uploads/admin/${data.admin_image}`;
                    setPreviewImage(img);
                })
                .catch((err) => console.error("Failed to fetch admin:", err));
        } else {
            const img = adminData.admin_image?.startsWith("http")
                ? adminData.admin_image
                : `http://dev-service.asraimmigration.ca/backend_service/uploads/admin/${adminData.admin_image}`;
            setPreviewImage(img);
        }
    }, [id, adminData]);

    return (
        <div className="admin-form-container">
            <div className="newsadd-header">
                <h2 className="newsadd-title">View Admin</h2>
                <div className="header-buttons">
                    <button onClick={() => navigate("/admin")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            <form className="admin-form-page">
                {/* ===== Image Section ===== */}
                <div className="image-upload-container">
                    <label htmlFor="admin_image" className="image-label">
                        {previewImage ? (
                            <img
                                src={previewImage}
                                alt="Admin"
                                className="admin-image-preview"
                            />
                        ) : (
                            <div className="image-placeholder">No Image</div>
                        )}
                    </label>
                    <p className="image-note">Admin Profile Image</p>
                </div>

                {/* ===== Row 1: Name + Email ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Admin Name</label>
                        <input
                            type="text"
                            name="admin_name"
                            value={admin.admin_name || ""}
                            readOnly
                        />
                    </div>
                    <div className="admin-form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={admin.email || ""}
                            readOnly
                        />
                    </div>
                </div>

                {/* ===== Row 2: Password + Phone ===== */}
                <div className="admin-form-row">
                    <div className="admin-form-group">
                        <label>Password</label>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={admin.original_password || admin.password || ""}
                                readOnly
                            />
                            <span
                                className="password-toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: "pointer" }}
                            >
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </span>
                        </div>
                    </div>

                    <div className="admin-form-group">
                        <label>Phone Number</label>
                        <input
                            type="text"
                            name="phone_number"
                            value={admin.phone_number || ""}
                            readOnly
                        />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AdminView;
